import { h, Component, Prop, Event, EventEmitter } from "@stencil/core";
import type { ErrorType } from "../types";
import { i18n } from "../../../utils/i18n";

@Component({
  tag: 'hd-auth-error',
  shadow: false
})
export class HdAuthError {
  @Prop() errorType: ErrorType = "signup";
  @Event() retryStep: EventEmitter<void>;

  t = i18n.get("hd-auth");
  error_message: string = this.t("error_messages", { returnObjects: true })

  handleRetry = () => {
    this.retryStep.emit();
  }

  render() {
    return (
      <div class="step-container error-container">
        <img src="https://s3.us-east-1.amazonaws.com/assets.adsttc.com/img/auth_error.svg"
          alt="" role="presentation" style={{ minHeight: "97px" }} />
        <div>
          <h3 class="title">{this.error_message[this.errorType]?.title}</h3>
          <p class="description">{this.error_message[this.errorType]?.description}</p>
        </div>
        <div class="step-actions grid">
          <button class="next-step" onClick={this.handleRetry}>{this.t("error.retry")}</button>
          <a class="button prev-step" href="https://www.archdaily.com/contact" target="_blank" rel="noopener noreferrer">
            {this.t("error.contact_support")}
          </a>
        </div>
      </div>
    )
  }
}
